import "@rails/actiontext"
import './trix_addon'
import './trix_config'
import './canned_comments'
import "controllers"
import axios from "axios"

// Add csrfToken to header of every requests
const csrfToken = document.querySelector("meta[name=csrf-token]").content
axios.defaults.headers.common['X-CSRF-Token'] = csrfToken